import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowBackOutlined } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';
import { makeStyles, Typography } from '@material-ui/core';

import { AppContext } from 'context';
import { Routes } from 'routes';
import MultiStepForm from 'components/Forms/MultiStepForm';
import client from 'services/client';
import { notify } from 'components/Notifier';
import { Step1, Step2, Step3 } from './BuyerCreateSteps';

const useStyles = makeStyles({
  headerTitle: {
    marginBottom: '2rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'center',
  },
  title: {
    margin: 0,
  },
});

const BuyerCreate: React.FC = () => {
  const context = useContext(AppContext);
  const sortingCenter = context.getSortingCenter?.();
  const history = useHistory();
  const { t } = useTranslation();
  const classes = useStyles();

  const steps = [
    { label: t('buyers.create.step1.title'), component: Step1, requiredFieldsLegend: true },
    { label: t('buyers.create.step2.title'), component: Step2, requiredFieldsLegend: true },
    { label: t('buyers.create.step3.title'), component: Step3, requiredFieldsLegend: true },
  ];

  return (
    <>
      <div className={classes.headerTitle}>
        <Typography variant="h1" className={classes.title}>
          {t('buyers.add.title')}
        </Typography>
      </div>
      <MultiStepForm
        formName={'closureCloseForm'}
        backRoute={Routes.Buyers}
        backIcon={<ArrowBackOutlined />}
        onSubmit={async e => {
          try {
            await client.post('/buyers', {
              ...e,
              sortingCenter: sortingCenter?.['@id'],
            });
            notify({
              message: t('buyers.create.successMessage', { label: e.name }),
              severity: 'success',
            });
            history.push(Routes.Buyers);
          } catch {
            notify({
              message: t('errorGeneric'),
              severity: 'error',
            });
          }
        }}
        steps={steps}
        initialData={{
          name: '',
          addressLine: '',
          postalCode: '',
          city: '',
          phoneNumber: '',
          contact: {
            lastName: '',
            firstName: '',
            email: '',
            phoneNumber: '',
          },
          acceptedMaterials: [],
        }}
      />
    </>
  );
};
export default BuyerCreate;
